import { render, staticRenderFns } from "./_reservationId.vue?vue&type=template&id=be193a52"
import script from "./_reservationId.vue?vue&type=script&lang=ts"
export * from "./_reservationId.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navbar: require('/vercel/path0/components/navbar.vue').default,UiIconCheck: require('/vercel/path0/components/ui/icon/check.vue').default,UiContainer: require('/vercel/path0/components/ui/container.vue').default})
